import { featureActions } from '../features'
import { STEAM_UPDATE } from '../constants'

const SteamMiddleware = store => next => (action) => {
    switch (action.type) {
        case STEAM_UPDATE: {
            // first get current steam startup value
            const wasSteam = store.getState().steam.steamStartup
            const result = next(action)
            const isSteam = store.getState().steam.steamStartup

            // Steam startup has changed, inform features...
            if (wasSteam !== isSteam) {
                store.dispatch(featureActions.steamChanged(isSteam))
            }

            return result
        }

        default:
            return next(action)
    }
}

export default SteamMiddleware



// WEBPACK FOOTER //
// ./src/middlewares/SteamMiddleware.js